module.exports = __webpack_public_path__ + "70eb93d7ba2ad241180085a9a74b0b95.svg";